import type { ClusteredTableRow, RawTableRow, SimilarityResponse } from "./types";

export const toTableRows = (
  data: SimilarityResponse
): { rawRows: RawTableRow[]; clusteredRows: ClusteredTableRow[] } => {
  const rawRows = data.rawData?.map((e) => ({
    date: e.row.dateString,
    euclideanDistance: e.euclideanDistance,
    cosineDistance: e.cosineDistance,
    normalizedEuclideanDistance: e.normalizedEuclideanDistance,
    normalizedCosineDistance: e.normalizedCosineDistance,
    euclideanRank: e.euclideanRank,
    cosineRank: e.cosineRank,
    close: e.row.close,
    contAdjustedClose: e.row.contAdjustedClose,
    stxUseScore: e.row.stxUseScore,
    seasonalScoreV1: e.row.seasonalScoreV1,
    seasonalScoreV2: e.row.seasonalScoreV2,
    mmScore: e.row.mmScore,
    algoScoreV3: e.row.algoScoreV3,
    rsi: e.row.rsi,
    ts2vec: e.row.ts2vec,
    meanLighthouseCorrelScore: e.meanLighthouseCorrelScore,
    rallyPercent10d: e.rallyPercent10d,
    rallyPercent15d: e.rallyPercent15d,
    rallyPercent20d: e.rallyPercent20d,
    rallyAmount10d: e.rallyAmount10d,
    rallyAmount15d: e.rallyAmount15d,
    rallyAmount20d: e.rallyAmount20d,
  })) || [];

  const clusteredRows = data.clusteredData?.map((e) => ({
    date: e.row.dateString,
    startDate: e.startDate,
    endDate: e.endDate,
    euclideanDistance: e.euclideanDistance,
    cosineDistance: e.cosineDistance,
    normalizedEuclideanDistance: e.normalizedEuclideanDistance,
    normalizedCosineDistance: e.normalizedCosineDistance,
    euclideanRank: e.euclideanRank,
    cosineRank: e.cosineRank,
    close: e.row.close,
    contAdjustedClose: e.row.contAdjustedClose,
    stxUseScore: e.row.stxUseScore,
    seasonalScoreV1: e.row.seasonalScoreV1,
    seasonalScoreV2: e.row.seasonalScoreV2,
    mmScore: e.row.mmScore,
    algoScoreV3: e.row.algoScoreV3,
    rsi: e.row.rsi,
    ts2vec: e.row.ts2vec,
    meanLighthouseCorrelScore: e.meanLighthouseCorrelScore,
    rallyPercent10d: e.rallyPercent10d,
    rallyPercent15d: e.rallyPercent15d,
    rallyPercent20d: e.rallyPercent20d,
    rallyAmount10d: e.rallyAmount10d,
    rallyAmount15d: e.rallyAmount15d,
    rallyAmount20d: e.rallyAmount20d,
  })) || [];

  return { rawRows: rawRows, clusteredRows: clusteredRows };
};

export const clamp = (value: number, min: number, max: number) =>
  Math.max(min, Math.min(max, value));

